import {Component, ElementRef, inject, input, OnChanges, Renderer2, SimpleChanges} from '@angular/core';
import {AsyncPipe} from "@angular/common";
import {map} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {TypewriterService} from "@core/services/typewriter.service";


@Component({
    selector: 'app-loading-overlay',
    templateUrl: './app-loading-overlay.component.html',
    styleUrls: ['./app-loading-overlay.component.scss'],
    standalone: true,
    imports: [
        AsyncPipe
    ]
})
export class AppLoadingOverlayComponent implements OnChanges {
    show = input<Boolean>(false);
    private typewriterService = inject(TypewriterService);
    private el = inject(ElementRef);
    private renderer = inject(Renderer2);
    private translateService = inject(TranslateService);

    text$ = this.typewriterService
        .getTypewriterEffect([this.translateService.instant('Estamos carregando os dados, por favor aguarde...')])
        .pipe(map((text) => text));


    ngOnChanges(changes: SimpleChanges): void {
        if (changes['show']) {
            this.setParentPositionRelative();
        }
    }

    private setParentPositionRelative(): void {
        const parentElement = this.el.nativeElement.parentElement;
        if (parentElement) {
            this.renderer.setStyle(parentElement, 'position', 'relative');
        }
    }
}
